import { FC } from "react";
import { Form, Grid } from "antd";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import TripDateSelectWeb from "./layouts/TripDateSelect.web";
import TripDateSelectMob from "./layouts/TripDateSelect.mob";

const TripDateSelectComponent = withConditionalComponent(TripDateSelectWeb, TripDateSelectMob);

const TripDateSelect: FC<any> = ({ value, onChange, label, icon, disabledDate, className, closeSheet, ...rest }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const errors = Form.Item.useStatus().errors;

  return (
    <TripDateSelectComponent
      trigger={isLargeScreen}
      props={{ value, onChange, label, icon, disabledDate, className, closeSheet, validationError: errors, ...rest }}
    />
  );
};

export default TripDateSelect;
